import React from 'react';
import { useResume } from '../context/ResumeContext';

export default function CustomSectionsForm({ sectionId }) {
  const { activeResume, updateField } = useResume();
  const data = activeResume?.[sectionId] || { title: '', content: '' };

  const handleTitleChange = (val) => {
    updateField(`${sectionId}.title`, val);
  };

  const handleContentChange = (val) => {
    updateField(`${sectionId}.content`, val);
  };

  const labelStyle = {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'var(--text-secondary)',
    marginBottom: '8px',
    display: 'block',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {/* Title */}
      <div>
        <label style={labelStyle}>Section Title</label>
        <input
          type="text"
          className="p-input"
          placeholder="e.g. Speaking Engagements / Conferences"
          value={data.title || ''}
          onChange={e => handleTitleChange(e.target.value)}
          style={{ width: '100%' }}
        />
      </div>

      {/* Content */}
      <div>
        <label style={labelStyle}>Section Content</label>
        <textarea
          className="p-input"
          rows={6}
          placeholder="Write your accomplishments or content here (e.g. - Spoke at PyCon on API performance...)"
          value={data.content || ''}
          onChange={e => handleContentChange(e.target.value)}
          style={{ width: '100%', minHeight: 140 }}
        />
      </div>
    </div>
  );
}
